export {default as path} from "./src/path";



//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/d3-path/index.js
// module id = ../../../../d3-path/index.js
// module chunks = 4